// // FOR TESTING PURPOSE
//export const SERVER_DOMAIN = "http://localhost:7000";

// export const SERVER_DOMAIN = "https://unichatbackend.onrender.com";
const LIVE_URL = process.env.REACT_APP_LIVE_URL;
export const SERVER_DOMAIN = LIVE_URL;